import { render, staticRenderFns } from "./SessionGate.vue?vue&type=template&id=07df0f8c"
import script from "./SessionGate.vue?vue&type=script&lang=ts"
export * from "./SessionGate.vue?vue&type=script&lang=ts"
import style0 from "./SessionGate.vue?vue&type=style&index=0&id=07df0f8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports